import React from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { message } from 'antd';
import { slackUserLogin } from '../troopr/authApi';
import {
  readReturnPath,
  clearReturnPath,
  withWorkspace,
  isWorkspaceScoped,
} from '../troopr/returnPath';

// Slack "Continue with Slack" callback. Slack redirects here (REACT_APP_URI =
// .../slack_login) with ?code. We exchange it via the NEW cookie endpoint
// (slackUserLogin → /bot/api/auth.slack.user.login), which sets the httpOnly
// cookie session — the same flow Google/email use. The legacy path here posted
// to /auth/slack/access, which only minted a Bearer token (no cookie), so the
// new auth gate never saw a session and bounced back to login.
//
// The token-exchange redirect_uri MUST equal the one goToSlackLogin sent to
// Slack — both are REACT_APP_URI — or Slack rejects the exchange.
class SlackAccessAuth extends React.Component {
  componentDidMount() {
    const code = queryString.parse(this.props.location.search).code;
    if (!code) {
      this.props.history.push('/troopr/access');
      return;
    }
    slackUserLogin({ code, redirectUri: process.env.REACT_APP_URI })
      .then((response) => {
        if (response.data && response.data.success) {
          // Slack identifies the workspace directly — skip the picker.
          const { workspaceId } = response.data;
          if (workspaceId) {
            localStorage.setItem('userCurrentWorkspaceId', workspaceId);
          }
          const returnPath = readReturnPath(window.location.search);
          const wId =
            workspaceId || localStorage.getItem('userCurrentWorkspaceId');
          if (returnPath && (isWorkspaceScoped(returnPath) || wId)) {
            clearReturnPath();
            window.location.href = withWorkspace(returnPath, wId);
          } else if (workspaceId) {
            window.location.href = `/${workspaceId}/dashboard`;
          } else {
            window.location.href = '/user-workspaces';
          }
        } else {
          message.error(
            (response.data && response.data.message) ||
              'Slack sign-in failed. Please try again.'
          );
          this.props.history.push('/troopr/access');
        }
      })
      .catch(() => {
        message.error('Slack sign-in failed. Please try again.');
        this.props.history.push('/troopr/access');
      });
  }

  render() {
    return <div></div>;
  }
}

export default withRouter(SlackAccessAuth);
